module.exports = __webpack_public_path__ + "static/media/banner.d266a4cf.png";